<div class="overlay"
     *ngIf="!['button', 'image', 'submit'].includes(overlay.type)"
     [hidden]="!isVisible"
     [ngStyle]="style"
     (click)="onClick($event)"
     [style.opacity]="opacity"
     [style.lineHeight]="1"
     [id]="overlay.uid"
     [style.left.%]="position.x"
     [style.top.%]="position.y"
>
  <ng-container *ngIf="overlay.type === 'text'">
    <span class="text" [innerHTML]="overlay.html | safeHtml"></span>
  </ng-container>
</div>
